angular.module('taric.units', [])
    // Filters
    .filter('isRetailPrice', require('./filters/is-retail-price'))
    .filter('isNotRetailPrice', require('./filters/is-not-retail-price'))
    ;
